import { useQuery } from '@apollo/client';

import { GetAddressBasedDispensaryDataDocument } from 'src/gql/graphql';
import type { AddressBasedDispensaryDataResult } from 'src/gql/graphql';

import useCart from 'hooks/use-cart';
import useUI from 'hooks/use-ui';

function useFilters(
  cNameOrId: string | null
):
  | {
      dispensaryId: string;
      ln1?: string;
      ln2?: string;
      city?: string;
      // Mapbox place name (e.g. "Brick" for a "Brick Township" address); lets the
      // server match township addresses against the place-based city zones admins
      // configure, so the fee/minimum shown here agrees with checkout validation.
      place?: string;
      state?: string;
      zipcode?: string;
      lat?: number;
      lng?: number;
    }
  | undefined {
  const Cart = useCart();
  const { isKiosk } = useUI();

  if (Cart?.currentAddress && !isKiosk && cNameOrId) {
    return {
      dispensaryId: cNameOrId,
      ln1: Cart?.currentAddress?.ln1,
      ln2: Cart?.currentAddress?.ln2,
      city: Cart?.currentAddress?.city,
      place: Cart?.currentAddress?.place,
      state: Cart?.currentAddress?.state,
      zipcode: Cart?.currentAddress?.zipcode,
      lat: Cart?.currentAddress?.lat,
      lng: Cart?.currentAddress?.lng,
    };
  }

  return undefined;
}

export default function useDispensaryDeliveryInfo(
  cNameOrId: string | null
): AddressBasedDispensaryDataResult | null | undefined {
  const filters = useFilters(cNameOrId);
  const result = useQuery(GetAddressBasedDispensaryDataDocument, {
    context: { cell: true },
    variables: { input: filters },
    skip: !cNameOrId || !filters,
  });

  return result.data?.getAddressBasedDispensaryData;
}
